import React, { useState } from 'react';
import '../../../styles/DeliverableModal.css';

const DeliverableModal = ({ show, onClose, data, onConfirm, onUnconfirm }) => {
  const [zoomImage, setZoomImage] = useState(null);
  if (!show || !data) return null;

  const {
    userId,
    curriculumName,
    sessionNumber,
    deliverables = [],
    confirmed = 0 // デフォルト: 未確認
  } = data;

  // 提出日（uploaded_at）で新しい順にソート
  const sortedDeliverables = [...deliverables].sort((a, b) =>
    new Date(b.uploaded_at) - new Date(a.uploaded_at)
  );

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h4>{curriculumName} 第{sessionNumber}回 の成果物</h4>
        <div className="deliverable-grid">
          {sortedDeliverables.map((file, index) => (
            <div key={index} className="deliverable-item">
              {file.file_type === 'other' && file.key?.toLowerCase().endsWith('.zip') ? (
                <>
                  <a
                    href={file.url}
                    download
                    className="zip-card"
                    title="クリックしてZIPをダウンロード"
                  >
                    <div className="zip-icon">🗜️</div>
                    <div className="zip-label">ZIPファイルをダウンロード</div>
                  </a>
                  <div className="zip-filename">
                    {file.key?.split('/').pop()}
                  </div>
                  {file.uploaded_at && (
                    <div className="zip-date">
                      {new Date(file.uploaded_at).toLocaleString('ja-JP', {
                        timeZone: 'Asia/Tokyo',
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                        hour: '2-digit',
                        minute: '2-digit',
                      })} 提出
                    </div>
                  )}
                </>
              ) : (
                <>
                  <div className="pdf-thumb">不明な形式</div>
                  <div className="zip-filename">{file.key?.split('/').pop()}</div>
                </>
              )}
            </div>
          ))}
        </div>

        {/* 成果物の有無に関係なく確認ボタンを表示 */}
        <div className="modal-buttons">
          {Number(confirmed) === 1 ? (
            <button
              className="secondary-button"
              onClick={() => onUnconfirm(userId, curriculumName, sessionNumber)}
            >
              未確認に戻す
            </button>
          ) : (
            <button
              className="primary-button"
              onClick={() => onConfirm(userId, curriculumName, sessionNumber)}
            >
              確認済みにする
            </button>
          )}
          <button onClick={onClose}>閉じる</button>
        </div>
      </div>

      {/* 拡大画像（拡張用） */}
      {zoomImage && (
        <div className="zoom-overlay" onClick={() => setZoomImage(null)}>
          <img src={zoomImage} alt="Zoomed Deliverable" className="zoomed-image" />
        </div>
      )}
    </div>
  );
};

export default DeliverableModal;
